export default __webpack_public_path__ + "static/media/755.3eff7ba2.gif";